import type { GetStaticProps } from 'next';
import dynamic from 'next/dynamic';

import wrapper from 'src/redux';
import { actionGetFooterMenu, actionGetMenu } from 'src/redux/actions';

const HeadC = dynamic(() => import('src/components/Head'));
const CareerContainer = dynamic(() => import('src/containers/Career'));

const CareerPage = () => {
	return (
		<>
			<HeadC
				title="Lowongan Kerja di KlikDokter"
				description={
					'Informasi lowongan kerja dan karier terbaru di KlikDokter. ' +
					'Kami membuka kesempatan bagi kamu untuk bergabung dan mengisi posisi-posisi ' +
					'strategis di sini.'
				}
				hideSuffix
			/>
			<CareerContainer />
		</>
	);
};

export const getStaticProps: GetStaticProps = wrapper.getStaticProps((store) => async () => {
	await store.dispatch(actionGetMenu());
	await store.dispatch(actionGetFooterMenu());

	return { props: {} };
});

export default CareerPage;
